import { j as a } from '../../../_virtual/jsx-runtime.js';
import { ProgressBar as e } from '../../atoms/ProgressBar/ProgressBar.js';
const i = ({ total: o, current: r }) =>
  r <= o &&
  /* @__PURE__ */ a.jsx('div', {
    className: 'flex gap-2 my-2 h-2 w-auto',
    children: Array.from({ length: o }).map((m, s) =>
      /* @__PURE__ */ a.jsx(e, { achieved: s < r, isCurrent: s === r - 1 }, s),
    ),
  });
export { i as ProgressBars };
